import { render, staticRenderFns } from "./user-register.vue?vue&type=template&id=d45e93a8&"
import script from "./user-register.vue?vue&type=script&lang=js&"
export * from "./user-register.vue?vue&type=script&lang=js&"
import style0 from "./user-register.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("F:\\Vuejs-Project\\subsappadminOrg\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('d45e93a8')) {
      api.createRecord('d45e93a8', component.options)
    } else {
      api.reload('d45e93a8', component.options)
    }
    module.hot.accept("./user-register.vue?vue&type=template&id=d45e93a8&", function () {
      api.rerender('d45e93a8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/auth/registration/user-register.vue"
export default component.exports